import { MouseCoordinates } from '../types'

const getEventArtboard = (eventPosition: MouseCoordinates) => {
  // Get the event path
  const eventPath = document.elementsFromPoint(
    eventPosition.clientX,
    eventPosition.clientY
  )

  for (const element of eventPath) {
    const permanentArtboardId =
      element instanceof HTMLElement && element.dataset['artboardUuid']

    if (permanentArtboardId) {
      return { permanentArtboardId, element } as const
    }
  }
}

export const getDotPositioningFromMouseCoordinates = (
  eventPosition: MouseCoordinates,
  origin: HTMLElement,
  scale: number
) => {
  let scalePrefixBounds
  let permanentArtboardId

  const originBounds = origin.getBoundingClientRect()
  const scaleOriginBounds = {
    x: (originBounds?.x || 0) / scale,
    y: (originBounds?.y || 0) / scale,
  }

  /**
   * Check if the dot is placed on top of a artboard
   */
  const artboardElement = getEventArtboard(eventPosition)

  if (artboardElement) {
    permanentArtboardId = artboardElement.permanentArtboardId
    const elementBounds = artboardElement.element.getBoundingClientRect()

    scalePrefixBounds = {
      x: elementBounds.x / scale - scaleOriginBounds.x,
      y: elementBounds.y / scale - scaleOriginBounds.y,
    }
  }

  /**
   * Calculate the position of the annotation regarding the origin
   */
  const position = {
    x:
      eventPosition.clientX / scale -
      (scalePrefixBounds?.x || 0) -
      scaleOriginBounds.x,
    y:
      eventPosition.clientY / scale -
      (scalePrefixBounds?.y || 0) -
      scaleOriginBounds.y,
  }

  return {
    position,
    permanentArtboardId,
    prefixBounds: scalePrefixBounds,
  }
}
